__turbopack_context__.v({
  "root": "calendar-styles-module-scss-module__RjDKdW__root",
});
